import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-66826ec4")

_pushScopeId("data-v-66826ec4")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "学習室作成", -1)
const _hoisted_4 = { class: "flex-grow flex flex-col items-center bg-primary-100 overflow-y-scroll pt-12" }
const _hoisted_5 = { class: "panel-container rounded-md bg-white pb-2 mb-16 lg:mb-8" }
const _hoisted_6 = { class: "flex items-center justify-between w-full table-header-color px-4 py-3" }
const _hoisted_7 = { class: "mr-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_table = _resolveComponent("m-table")
  const _component_mr_add_modal = _resolveComponent("mr-add-modal")
  const _component_mr_delete_registrant_modal = _resolveComponent("mr-delete-registrant-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: "学習室情報",
          breadcrumbs: [],
          tabs: _ctx.tabs,
          "current-tab-index": _ctx.currentTabIndex
        }, _createSlots({ _: 2 }, [
          (_ctx.isAdmin || _ctx.allowCreateRoom)
            ? {
                name: "actions",
                fn: _withId(() => [
                  _createVNode(_component_m_button, {
                    color: "secondary-500",
                    "hover-color": "secondary-600",
                    outline: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDisplayedAddRoomModal = true))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_m_icon, {
                        type: "plus",
                        width: "3",
                        class: "mr-2 transform rotate-90 z-0"
                      }),
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ])
              }
            : undefined
        ]), 1032, ["tabs", "current-tab-index"]),
        _createVNode("main", _hoisted_4, [
          _createVNode("section", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchKeyword = $event)),
                  type: "search",
                  name: "searchStudent",
                  placeholder: "ユーザーネームで検索...",
                  class: "w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                }, null, 512), [
                  [_vModelText, _ctx.searchKeyword]
                ])
              ])
            ]),
            _createVNode(_component_m_table, {
              datas: _ctx.filteredDatas,
              definitions: _ctx.definitions,
              "default-sort-key": "name",
              editable: _ctx.isAdmin,
              onSelect: _ctx.openDeleteRegistrantModal
            }, null, 8, ["datas", "definitions", "editable", "onSelect"])
          ])
        ])
      ])
    ]),
    ((_ctx.isAdmin || _ctx.allowCreateRoom) && _ctx.isDisplayedAddRoomModal)
      ? (_openBlock(), _createBlock(_component_mr_add_modal, {
          key: 0,
          school: _ctx.school,
          groups: _ctx.groups,
          targets: _ctx.targets,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDisplayedAddRoomModal = false))
        }, null, 8, ["school", "groups", "targets"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin && _ctx.isDisplayedDeleteRegistrantModal && _ctx.selectedStudent)
      ? (_openBlock(), _createBlock(_component_mr_delete_registrant_modal, {
          key: 1,
          student: _ctx.selectedStudent,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayedDeleteRegistrantModal = false))
        }, null, 8, ["student"]))
      : _createCommentVNode("", true)
  ], 64))
})